// @flow
import React from 'react';
import type { ComponentType } from 'react';
import moment from 'moment';

import type { TimeCellPropTypes } from '../Cells/Time';
import TimeCell from '../Cells/Time';
import TextCell from '../Cells/Text';

type TimePropsTypes = {
  accessor: string | Function,
  Header: string | ComponentType<*> | React$Node,
  editable?: boolean,
  onChange?: (Object, string | number) => mixed,
  isHighlight?: boolean
};

const Time = ({
  accessor,
  Header,
  editable = false,
  onChange,
  isHighlight = false,
  ...props
}: TimePropsTypes) => ({
  Header,
  accessor,
  Cell: ({ value, ...cProps }: TimeCellPropTypes) => (
    editable ? (
      <TimeCell
        value={value}
        onChange={onChange}
        {...cProps}
      />
    ) : (
      <TextCell
        value={moment(value, ['hh:mm a', 'H:m']).format('h:mm A').toString()}
        editable={editable}
        onChange={onChange}
        isHighlight={isHighlight}
        {...cProps}
      />
    )
  ),
  ...props,
});


export default Time;



// WEBPACK FOOTER //
// ./src/scripts/components/DataTable/Columns/Time.jsx